/**
 * Created by js on 06.03.2018.
 */

class VideoOverlay{
    
    init()
    {
        //console.log("VideoOverlay init");
        this.$overlay = $('#overlay');
        this.$btn_close = this.$overlay.find("#btn-close-overlay");
        this.videoplayer = this.$overlay.find('#video-player')[0];

        this.$videolink = $('#video-link');
        this.addListeners();


        //if youtube player, use... and customize!
        /*
        // Load the IFrame Player API code asynchronously.
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Replace the 'ytplayer' element with an <iframe> and
        // YouTube player after the API code downloads.
        window.player = null;

        window.onYouTubePlayerAPIReady = function() {
            window.player = new YT.Player('video-player', {
                height: '360',
                width: '640',
                videoId: 'M7lc1UVf-VE'
            });
        }
        */
    }

    addListeners()
    {
        this.$videolink.css('cursor', 'pointer').click($.proxy(this.showOverlay, this));
        this.$btn_close.click($.proxy(this.hideOverlay, this));
    }

    showOverlay(e)
    {
        this.$overlay.fadeIn();
        this.videoplayer.play();

    }

    hideOverlay(e)
    {
        this.videoplayer.pause();
        this.videoplayer.currentTime = 0;
        this.$overlay.fadeOut();
        return false;
    }
}

//export only instance ( =  singleton like)
export let video_overlay = new VideoOverlay();


// WEBPACK FOOTER //
// ./src/script/video-overlay.js